
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"54.8","height":"37.9"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"フッター　カレンダー","fill":"#6d6c6f"}},[_c('path',{attrs:{"d":"M34.584 2.1h-1.105V0h-2.211v2.1h-8.842V0h-2.21v2.1h-1.105A2.164 2.164 0 0016.9 4.2v14.7a2.164 2.164 0 002.211 2.1h9.947a6.535 6.535 0 01-1.658-2.1h-8.289V7.35h15.473v2.73a5.482 5.482 0 012.211.735V4.2a2.164 2.164 0 00-2.211-2.1m-1.105 9.975a4.115 4.115 0 013.095 1.26l1.326-1.26v4.2h-4.421l1.989-1.89a3.273 3.273 0 00-1.989-.735 2.628 2.628 0 100 5.25 2.94 2.94 0 002.211-1.05h1.879a4.34 4.34 0 01-4.089 2.625 4.327 4.327 0 01-4.421-4.2 4.327 4.327 0 014.42-4.2z"}}),_c('text',{attrs:{"transform":"translate(.4 36.5)","stroke":"#6d6c6f","stroke-width":".4","font-size":"11","font-family":"HiraKakuProN-W3, Hiragino Kaku Gothic ProN"}},[_c('tspan',{attrs:{"x":"0","y":"0"}},[_v('カレンダー')])])])])
          )
        }
      }
    